import React, { FC, ReactNode } from 'react';

import { StartOrderEmptyState } from 'features/account/orders/start-order-empty-state';
import { StyleSheet, View } from 'react-native';

import { Wrap } from './styled';

interface IOrdersEmptyProps {
  children?: ReactNode;
}

const OrdersEmpty: FC<React.PropsWithChildren<IOrdersEmptyProps>> = ({ children }) => {
  return (
    <View style={styles.wrapper}>
      <Wrap>
        <StartOrderEmptyState />
      </Wrap>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    flexGrow: 1,
  },
});

export default OrdersEmpty;
